export enum RestaurantStatus {
  OWNED = 'OWNED',
  EMPTY = 'EMPTY',
  CHAIN = 'CHAIN',
  ARCHIVED = 'ARCHIVED'
}
